import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable, Injector } from "@angular/core";
import { exhaustMap, take } from "rxjs";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor{

    constructor(private __injector:Injector){}

    intercept(req: HttpRequest<any>, next: HttpHandler): any {
        
        let authService = this.__injector.get(AuthService);
        return authService.user.pipe(
            take(1),
            exhaustMap((user:any)=>{                
                if (!user) {
                    return next.handle(req);
                }
                const modifiedReq = req.clone({
                    setHeaders : {
                        'Authorization': user.token,
                        'Application-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone
                    }
                });
                return next.handle(modifiedReq);
            })
        );
    }

}